var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "37.379px",
    height: "37.382px",
    viewBox: "13.497 6.748 37.379 37.382",
    enableBackground: "new 13.497 6.748 37.379 37.382",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1664A5",
    d: "M32.359,6.75c10.426,0.152,18.688,8.603,18.514,18.936c-0.175,10.344-8.596,18.563-18.896,18.443 c-10.331-0.121-18.611-8.639-18.479-19.007C13.63,14.93,22.18,6.602,32.359,6.75 M32.123,33.361c2.484,0,4.971,0.026,7.455-0.007 c2.387-0.031,3.988-1.652,4.007-4.027c0.021-2.564,0.019-5.131,0-7.696c-0.019-2.503-1.636-4.121-4.155-4.131 c-4.81-0.018-9.62-0.02-14.43,0c-2.578,0.01-4.191,1.626-4.222,4.219c-0.029,2.484-0.033,4.971,0.001,7.456 c0.036,2.589,1.653,4.166,4.248,4.186C27.393,33.377,29.758,33.363,32.123,33.361"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1664A5",
    d: "M36.064,25.429c-2.604,1.692-5.034,3.274-7.61,4.95v-9.887C30.997,22.142,33.43,23.719,36.064,25.429"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.2b9e35857acfc405e4418817d0fa2463.svg";
export { ForwardRef as ReactComponent };